/**
 * サービスレベル検索まわりのファイル表示・ダウンロード URL を生成する。
 * 非公開バケットでは buildUrl() が imgix の x-lib 等を付与し CloudFront 署名と矛盾して 403 になるため、
 * 署名クエリ（Policy / Signature / Key-Pair-Id）のみを付与する。
 */
export const buildServiceLevelSignedFileUrl = (filePath: string): string => {
  const imgix = $core.$imgix
  if (!filePath) {
    return ''
  }

  if (imgix.isBucketPublic) {
    return imgix.buildUrl(filePath)
  }

  const signedUrl = imgix.cloudfrontSignedUrlForCoreFiles
  if (!signedUrl) {
    console.warn(
      '[YhcServiceLevel] cloudfrontSignedUrlForCoreFiles is empty, fallback to buildUrl',
    )
    return imgix.buildUrl(filePath)
  }

  try {
    const signedUrlObj = new URL(signedUrl)
    const normalizedPath = filePath.replace(/^\//, '')
    const objectUrl = new URL(
      `${signedUrlObj.protocol}//${signedUrlObj.host}/${normalizedPath}`,
    )
    signedUrlObj.searchParams.forEach((value, key) => {
      objectUrl.searchParams.set(key, value)
    })
    return objectUrl.toString()
  } catch (e) {
    console.warn('[YhcServiceLevel] failed to build signed file url', e)
    return imgix.buildUrl(filePath)
  }
}
